////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEqual, isNull, isEmpty } from 'lodash'
///////COMPONENTS///////
import PriceCampaignUpdateHandler from '../../ScheduledPricesManager/PriceCampaignUpdateHandler'
import PromoCampaignUpdateHandler from '../../ScheduledPromoManager/PromoCampaignUpdateHandler'
import { campaignPriceActionCreators, campaignPromoActionCreators } from '../../../store/actions'

//////STYLED//////
const NestedUpdateCampaignWrapper = styled.div``
//////STYLED//////

const NestedUpdateCampaign = (props) => {
	const { campaign, successCreateCampaign, campaignErrors, successCreateCampaignPromo, campaignPromoErrors, campaignPromo } = useSelector(
		(state) => ({
			campaign: state.campaignPrice.campaign,
			campaignPromo: state.campaignPromo.campaign,
			successCreateCampaign: state.campaignPrice.update || false,
			campaignErrors: state.campaignPrice.error?.data || [],
			successCreateCampaignPromo: state.campaignPromo.update || false,
			campaignPromoErrors: state.campaignPromo.error?.data || [],
		}),
		shallowEqual
	)

	const campaignPriceActions = bindActionCreators(campaignPriceActionCreators, useDispatch())
	const campaignPromoActions = bindActionCreators(campaignPromoActionCreators, useDispatch())

	const [showModalEditCampaignNested, setShowModalEditCampaignNested] = useState(false)
	const [showModalEditCampaignNestedPromo, setShowModalEditCampaignNestedPromo] = useState(false)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleModalPromo = (dataRow) => {
		// back call
		if (!showModalEditCampaignNestedPromo && !isNull(dataRow.id)) {
			campaignPromoActions.getCampaignPromo(dataRow.id)
			setShowModalEditCampaignNestedPromo(true)
		} else {
			setShowModalEditCampaignNestedPromo(false)
			campaignPromoActions.resetCampaignPromo()
			props.setNestedRow({})
			props.handleSubmitFilter(true)
		}
	}

	const handleModalEditCampaign = (dataRow) => {
		// back call
		if (!showModalEditCampaignNested && !isNull(dataRow.id)) {
			campaignPriceActions.getCampaign(dataRow.id)
			setShowModalEditCampaignNested(true)
		} else {
			setShowModalEditCampaignNested(false)
			campaignPriceActions.resetCampaign()
			props.setNestedRow({})
			props.handleSubmitFilter(true)
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (isEmpty(props.nestedRow)) return

		if (props.nestedRow.isPromo) {
			handleModalPromo(props.nestedRow)
		} else {
			handleModalEditCampaign(props.nestedRow)
		}
	}, [props.nestedRow])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<NestedUpdateCampaignWrapper>
			{!isEqual(campaign, {}) && showModalEditCampaignNested && (
				<PriceCampaignUpdateHandler
					closeModalHandler={() => {
						handleModalEditCampaign(props.nestedRow)
					}}
					showModal={showModalEditCampaignNested}
					data={cloneDeep(campaign)}
					widthTaxes={props.withTaxes}
					campaignErrors={campaignErrors}
					successCreateCampaign={successCreateCampaign}
					setNestedRow={props.setNestedRow}
					updateMode
				/>
			)}
			{!isEqual(campaignPromo, {}) && showModalEditCampaignNestedPromo && (
				<PromoCampaignUpdateHandler
					closeModalHandler={() => {
						handleModalPromo(props.nestedRow)
					}}
					showModal={showModalEditCampaignNestedPromo}
					data={cloneDeep(campaignPromo)}
					withTaxes={props.withTaxes}
					campaignErrors={campaignPromoErrors}
					setNestedRow={props.setNestedRow}
					successCreateCampaign={successCreateCampaignPromo}
					target={'byKiosk'}
				/>
			)}
		</NestedUpdateCampaignWrapper>
	)
}

NestedUpdateCampaign.propTypes = {}

NestedUpdateCampaign.defaultPropTypes = {}

export default NestedUpdateCampaign
